export const sizesSubTitle = [
    {
        text: "You can change the size of avatar using ",
        code: '.img- *  (70/80/90/100)'
    },
    {
        text: ' class.'
    }
];

export const statusSubTitle = [
    {
        text: "Using ",
        code: ' .status-* (online/offline/dnd)'
    },
    {
        text: ' class you can set the status of avatar.'
    }
];

export const shapesSubTitle = [
    {
        text: "Using the",
        code: '.b-r-* (8/30/35/25)'
    },
    {
        text: ' class you can set the shapes of avatar.'
    }
];

export const ratioSubTitle = [
    {
        text: "Give the shape to avatar using ",
        code: '.radio'
    },
    {
        text: ' and',
        code: ' img-* (50/70/80/90/100)'
    },
    {
        text: ' class.'
    }
];

export const groupSubTitle = [
    {
        text: "You can set the group of avatars like ",
        code: '.img-* (40/50/60/80/100) '
    },
    {
        text: 'and',
        code: ' .b-r-* (8/30/35)'
    },
    {
        text: '.'
    }
]


export const avatarSizeData = [
    {
        class: '100',
        image: '11.jpg'
    },
    {
        class: '90',
        image: '9.jpg'
    },
    {
        class: '80',
        image: '5.jpg'
    },
    {
        class: '70',
        image: '6.jpg'
    }
];

export const avatarStatusData = [
    {
        class: '100',
        image: '1.jpg',
        status: 'success'
    },
    {
        class: '90',
        image: '2.jpg',
        status: 'warning'
    },
    {
        class: '80',
        image: '3.jpg',
        status: 'danger'
    },
    {
        class: '70',
        image: '4.jpg',
        status: 'success'
    }
]

export const avatarShapeData = [
    {
        class: '100 b-r-8',
        image: '8.jpg'
    },
    {
        class: '90 b-r-30',
        image: '5.jpg'
    },
    {
        class: '80 b-r-35',
        image: '11.jpg'
    },
    {
        class: '70 rounded-circle',
        image: '4.jpg'
    }
]

export const avatarRatioData = [
    {
        class: '100',
        image: 'avtar/9.jpg'
    },
    {
        class: '90',
        image: 'avtar/1.jpg'
    },
    {
        class: '80',
        image: 'user/3.jpg'
    },
    {
        class: '70',
        image: 'avtar/6.jpg'
    },
    {
        class: '50',
        image: 'avtar/3.jpg'
    }
];

export const avatarGroupData = [
    {
        id: 1,
        child: [
            {
                id: 1,
                class: '100 b-r-8',
                image: '10.jpg' 
            },
            {
                id: 2,
                class: '80 b-r-30',
                image: '4.jpg' 
            },
            {
                id: 3,
                class: '50 b-r-35',
                image: '8.jpg' 
            },
        ]
    },
    {
        id: 2,
        child: [
            {
                id: 1,
                class: '60 rounded-circle',
                image: '11.jpg' 
            },
            {
                id: 2,
                class: '80 b-r-8',
                image: '9.jpg' 
            },
            {
                id: 3,
                class: '60 rounded-circle',
                image: '4.jpg' 
            },
        ]
    },
    {
        id: 3,
        child: [
            {
                id: 1,
                class: '40 rounded-circle',
                image: '1.jpg' 
            },
            {
                id: 2,
                class: '40 rounded-circle',
                image: '2.jpg' 
            },
            {
                id: 3,
                class: '40 rounded-circle',
                image: '3.jpg' 
            },
        ]
    },
]